// Adaptado da biblioteca https://github.com/lopezton/jquery-creditcard-formatter
export default class MascaraCartaoCredito {
  /**
   *
   */
  card_types = [
    {
      name: "Elo",
      code: "elo",
      pattern:
        /^4011|438935|45(1416|76)|50(4175|6699|67|90[4-7])|63(6297|6368)/, //https://gist.github.com/keitoliveira/cd4ee720bf1923a28be3
      valid_length: [16],
      formats: [
        {
          length: 16,
          format: "xxxx xxxx xxxx xxxx",
        },
      ],
    },
    {
      name: "American Express",
      code: "ax",
      pattern: /^3[47]/,
      valid_length: [15],
      formats: [
        {
          length: 15,
          format: "xxxx xxxxxxx xxxx",
        },
      ],
    },
    {
      name: "Diners Club",
      code: "dc",
      pattern: /^3[68]/,
      valid_length: [14],
      formats: [
        {
          length: 14,
          format: "xxxx xxxx xxxx xx",
        },
      ],
    },
    {
      name: "JCB",
      code: "jc",
      pattern: /^35/,
      valid_length: [16],
      formats: [
        {
          length: 16,
          format: "xxxx xxxx xxxx xxxx",
        },
      ],
    },
    {
      name: "Visa",
      code: "vs",
      pattern: /^4/,
      valid_length: [16],
      formats: [
        {
          length: 16,
          format: "xxxx xxxx xxxx xxxx",
        },
      ],
    },
    {
      name: "Mastercard",
      code: "mc",
      pattern: /^5[1-5]/,
      valid_length: [16],
      formats: [
        {
          length: 16,
          format: "xxxx xxxx xxxx xxxx",
        },
      ],
    },
    {
      name: "Discover",
      code: "discover",
      pattern: /^6/,
      valid_length: [16],
      formats: [
        {
          length: 16,
          format: "xxxx xxxx xxxx xxxx",
        },
      ],
    },
  ];

  /**
   *
   */
  isValidLength = (cc_num, card_type) => {
    for (var i in card_type.valid_length) {
      if (cc_num.length <= card_type.valid_length[i]) {
        return true;
      }
    }
    return false;
  };

  /**
   *
   */
  getCardType = (cc_num) => {
    for (var i in this.card_types) {
      var card_type = this.card_types[i];
      if (
        cc_num.match(card_type.pattern) &&
        this.isValidLength(cc_num, card_type)
      ) {
        return card_type;
      }
    }
  };

  /**
   *
   */
  getCardFormatString = (cc_num, card_type) => {
    for (var i in card_type.formats) {
      var format = card_type.formats[i];
      if (cc_num.length <= format.length) {
        return format.format;
      }
    }
  };

  /**
   *
   */
  formatCardNumber = (cc_num, card_type) => {
    var numAppendedChars = 0;
    var formattedNumber = "";

    if (!card_type) {
      return cc_num;
    }

    var cardFormatString = this.getCardFormatString(cc_num, card_type);
    for (var i = 0; i < cc_num.length; i++) {
      const cardFormatIndex = i + numAppendedChars;
      if (!cardFormatString || cardFormatIndex >= cardFormatString.length) {
        return cc_num;
      }

      if (cardFormatString.charAt(cardFormatIndex) !== "x") {
        numAppendedChars++;
        formattedNumber +=
          cardFormatString.charAt(cardFormatIndex) + cc_num.charAt(i);
      } else {
        formattedNumber += cc_num.charAt(i);
      }
    }

    return formattedNumber;
  };

  /**
   *
   */
  monitorCcFormat = ($elem) => {
    var cc_num = $elem.val().replace(/\D/g, "");
    var card_type = this.getCardType(cc_num);
    $elem.val(this.formatCardNumber(cc_num, card_type));
    this.addCardClassIdentifier($elem, card_type);
  };

  /**
   *
   */
  addCardClassIdentifier = ($elem, card_type) => {
    var classIdentifier = "cc_type_unknown";
    if (card_type) {
      classIdentifier = "cc_type_" + card_type.code;
    }

    if (!$elem.hasClass(classIdentifier)) {
      var classes = "";
      for (var i in this.card_types) {
        classes += "cc_type_" + this.card_types[i].code + " ";
      }
      $elem.removeClass(classes + "cc_type_unknown");
      $elem.addClass(classIdentifier);
    }
  };

  aplicar = (elements) => {
    elements.each((index, elem) => {
      let el = $(elem);
      el.on("input", () => {
        this.monitorCcFormat(el);
      });
    });
  };
}
